import { TranslateService } from '@ngx-translate/core';

import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ToastComponent } from '@/app/shared/components/ui/toast';

import { getUserLocale } from '@/app/shared/utils/user-locale';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, ToastComponent],
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    this.setLocale();
  }

  private setLocale() {
    const selectedLang = getUserLocale();

    this.translate.setDefaultLang(selectedLang);
    this.translate.use(selectedLang);
  }
}
